import { ForemanDB } from "../../types/IndexedDB/ForemanDB"
import { DirectReportAttendance } from "../../types/Employee/Attendance"
import { showErrorToast } from "../CommonServices/alertServices"

export const mapAttendance = async (db: ForemanDB, newAttendance: DirectReportAttendance[]) => {
    try {
        await db.transaction('rw', [db.attendance], async () => {
            db.setHooksEnabled(false)
            await db.attendance.clear()
            await db.attendance.bulkAdd(newAttendance)
            db.setHooksEnabled(true)
        })
    } catch (error) {
        showErrorToast({
            message: 'Error mapping attendance',
        })
    }
}